import { render } from "./DbEntitiesList.vue?vue&type=template&id=6cc3b1b2&scoped=true"
import script from "./DbEntitiesList.vue?vue&type=script&lang=js"
export * from "./DbEntitiesList.vue?vue&type=script&lang=js"

import "./DbEntitiesList.vue?vue&type=style&index=0&id=6cc3b1b2&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc3b1b2"]])

export default __exports__